"use client";

import { c as _c } from "react/compiler-runtime";
import ImageWithText from "@/components/ui/imagewithtext";
import SocialIcons from "@/components/header/SocialIcons";
import { getFocusPointStyle, ImageMetadata } from '@/lib/componentutills';
type Props = {
  text?: string;
  imageSrc?: string;
  priority?: boolean;
  imageMetadata?: ImageMetadata;
};
export default function TextWithBigImageAndIcon(t0) {
  const $ = _c(7);
  const {
    text: t1,
    imageSrc: t2,
    priority: t3
  } = t0;
  const text = t1 === undefined ? "\u0BB5\u0BC6\u0BB1\u0BCD\u0BB1\u0BBF\u0B95\u0BB0\u0BAE\u0BBE\u0B95 \u0B8F\u0BB5\u0BAA\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BA4\u0BC1 \u0B9A\u0BA8\u0BCD\u0BA4\u0BBF\u0BB0\u0BAF\u0BBE\u0BA9\u0BCD 3..." : t1;
  const imageSrc = t2 === undefined ? "https://media.dinamani.com/dinamani/2026-02-27/2bygxk4p/rocket.png" : t2;
  const priority = t3 === undefined ? false : t3;
  let t4;
  if ($[0] !== imageSrc || $[1] !== priority || $[2] !== text) {
    t4 = <ImageWithText text={text} imageSrc={imageSrc} priority={priority} />;
    $[0] = imageSrc;
    $[1] = priority;
    $[2] = text;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="absolute top-4 right-4 z-10"><SocialIcons /></div>;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t4) {
    t6 = <div className="w-full relative">{t4}{t5}</div>;
    $[5] = t4;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
}